import React from 'react'
import cn from '../CodingNinjas.jpeg';
import image3 from '../jb.jpeg';
import codingninjas from '../../src/codingninjas.png'


function Experience() {
    return (
<div>
<div className="mainHeadingAbout">
               EXPERIENCE
    </div>
        <div className= "expmain">
       


<div className="boxeach">
  
        <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
	<div class="flipper" >
		<div class="front" >
        <div className="nokia-image"></div>
 <div className="halfflipcard">
        <div className="headingexp"> Nokia, Ottawa, Canada </div>
        
            
            <div className="durationexp"> Sept 2022 - Present </div>
		</div>
        </div>
		<div class="back">
        <div className="contentexp">
        Developed XDP firewall and tested in Nokia’s cluster, worked on eBPF for anomaly and OOM Kill detection along
with it’s analysis/prediction in cloud environment. Developed IoTSAFE APIs in Java, developed an android app to get MNO information<br></br>
<b>Got recognition for being in top 5 Nokia’s got talent across the globe</b>, recognised for sharing my knowledge
with Nokia’s interns
		</div>
		</div>
	</div>
    
</div>
</div>



   
<div className="boxeach">
  
        <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
	<div class="flipper" >
		<div class="front" >
        <div className="uwindsor-image"></div>
 <div className="halfflipcard">
        <div className="headingexp"> University Of Windsor, Canada </div>
        
            <div className="positionexp"> Coding Coach, ICPC North America </div>
            <div className="durationexp"> Sept 2021 - Feb 2022 </div>
		</div>
        </div>
		<div class="back">
        <div className="contentexp">
        Taught data structures and algorithms to undergrad students of University of Windsor for International Collegiate
Programming Contest(ICPC) 2022 by conducting weekly sessions 
		</div>
		</div>
	</div>
    
</div>
</div>





      
       <div className="boxeach">
  
        <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
	<div class="flipper" >
		<div class="front" >
        <div className="iiit-image"></div>
 <div className="halfflipcard">
        <div className="headingexp"> IIIT (Institute of National Importance) </div>
        
            <div className="positionexp"> Researcher </div>
            <div className="durationexp"> Jan 2021 - June 2021 </div>
		</div>
        </div>
		<div class="back">
        <div className="contentexp">
        Worked on Neural Architecture Search for compressed and pixel images. <br></br>
        Currently working on word spotting in handwritten documents.
		</div>
		</div>
	</div>
    
</div>
</div>



<div className="boxeach">
         <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
     <div class="flipper">
         <div class="front ">
         <div className="coding-ninjas-image"></div>
 <div className="halfflipcard">
         <div className="headingexp"> Coding Ninjas </div>
             <div className="positionexp"> Content Associate </div>
             <div className="durationexp"> May 2021 - Jan 2021 </div>
         </div>
         </div>
         <div class="back">
         <div className="contentexp">
         Worked on creating Computer Science curriculum that can help students develop ability to think logically and independently.<br></br>
 Personally trained about 15 students in various technologies including python, web development(front end), programming logic and algorithms.</div>
         
         </div>
     </div>
 </div>
 </div>
</div>

 <div className="mainHeadingAbout">
               INTERNSHIPS (During undergrad)
    </div>
<div className="expmain">
<div className="boxeach">
<div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
	<div class="flipper">
		<div class="front ">
        <div className="kalpavriksh-image"></div>
 <div className="halfflipcard">
			<div className="headingexp"> Kalpavriksh Healthcare </div>
            <div className="positionexp"> Research Intern(Part-time) </div>
            <div className="durationexp"> June 2018 - April 2020 </div>
            
		</div>
        </div>
		<div class="back">
        <div className="contentexp">
        <b>Tech Stack: Python, Java, Android development, Machine Learning</b><br></br>
        <b>Project 1:</b> Developed an Android app for Type-1 diabetes patients and did data analysis in Python(Funded from AIIMS, Delhi)
App is live with 650,000+ hits as of Jan 17, 2021.<br></br>

<b>Project 2: </b>
Worked on analysis of type-2 diabetes data of 403 patients in Python.
Research paper published in IJEM journal</div>
		</div>
	</div>
</div>
</div>

 <div className="boxeach">
 <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
     <div class="flipper">
         <div class="front  ">
         <div className="iiit-image"></div>
 <div className="halfflipcard">
             <div className="headingexp"> IIIT Allahabad </div>
             <div className="positionexp"> Research Intern </div>
             <div className="durationexp"> June 2019 - July 2019 </div>
             
         </div>
         </div>
         <div class="back">
         <div className="contentexp">
         <b>Tech Stack: Python, Machine Learning, Deep Learning, Tensorflow</b><br></br>
Research paper published in Springer Singapore AISC Conference, Feb 2020<br></br>

Developed the Resnet network and made it deeper by introducing another loop. Compared it with other state of the art algorithms.
                 </div>
         </div>
     </div>
 </div>
 </div>

 <div className="boxeach">
 <div  class="flip-container" ontouchstart="this.classList.toggle('hover');">
     <div class="flipper">
         <div class="front  ">
         <div className="coding-ninjas-image"></div>
 <div className="halfflipcard">
             <div className="headingexp"> Coding Ninjas </div>
             <div className="positionexp"> Teaching Assistant </div>
             <div className="durationexp"> Aug 2017 - Nov 2017 </div>
             
         </div>
         </div>
         <div class="back">
         <div className="contentexp">
         <b>Tech stack: Data structures and algorithms in Java</b><br></br>
         Worked as TA for data structures and algorithms in Java for a batch of about 50 students.
                 </div>
         </div>
     </div>
 </div>
 </div>
 
 </div>
 
        </div>

    
       
        
 
    )
}

export default Experience
